import { useEffect } from 'react';
import { clearMultiSelection } from '@components/MainStage/clearMultiSelection';
import { filtersSubject } from '@context/ProjectFilters/FiltersSubject';
import { skip } from 'rxjs';

/**
 * Applying or changing any scope / basic filter clears and exits the
 * multi-selection. All filter changes (scope domains, validation, review,
 * operational, partners, CIA) flow through `filtersSubject`, so a single
 * subscription covers them.
 *
 * The first `BehaviorSubject` replay value (emitted synchronously on subscribe)
 * is skipped so mounting the canvas never clears an existing selection.
 */
const useClearSelectionOnFilters = () => {
  useEffect(() => {
    const subscription = filtersSubject
      .pipe(skip(1))
      .subscribe(() => clearMultiSelection());

    return () => subscription.unsubscribe();
  }, []);
};

export default useClearSelectionOnFilters;
